import store from './store/index'
import { Get, GetList } from '@/axios/IProject'
import { GetUserInfo } from '@/axios/IGetData'
import { getQueryParams } from '@/utils/str.js'

let XC_IP = ''
if (process.env.VUE_APP_XC_IFRAME_URL) {
  const _url = new URL(process.env.VUE_APP_XC_IFRAME_URL)
  XC_IP = _url.origin
}

let whiteList = process.env.VUE_APP_XC_POSTMSG_WHITE_LIST
if (whiteList && typeof whiteList === 'string') {
  whiteList = JSON.parse(whiteList)
}

if (!whiteList) {
  whiteList = ['http://star-test.opple.com', 'http://localhost:8080', 'http://localhost:9999', 'http://60.204.150.157:11198', 'http://10.0.99.70:11198', 'http://10.1.181.240:11117', 'http://10.1.181.240:11120', 'http://60.204.150.157:11120']
}

async function initProject({ projectCode, uuid }) {
  store.dispatch('changeProjectcode', projectCode)
  XC_IP = window.fatherOrigin || XC_IP
  return Promise.all([
    GetUserInfo(),
    Get({
      projectCode,
    }),
  ])
    .then(([userRes, projectRes]) => {
      debugger
      if (userRes.Result) {
        store.dispatch('changeUserinfor', userRes.Result)
      }

      if (projectRes.Result) {
        const headUrl = projectRes.Result.HeadImagePath || 'https://appresource.opple.com/media/business/4974/20241114101350_76.png'

        store.dispatch('changeProjectinfor', projectRes.Result)
        store.dispatch('changeUserhead', headUrl)

      }

      if (window.parent && window.parent.postMessage && uuid) {
        window.parent.postMessage({ type: 'XC_RESPONSE', payload: { uuid, result: true } }, XC_IP)
      }
    })
    .catch(() => {
      if (window.parent && window.parent.postMessage && uuid) {
        window.parent.postMessage({ type: 'XC_RESPONSE', payload: { uuid, result: false } }, XC_IP)
      }
    })
}

async function isNeedInjectionToken() {
  const query = getQueryParams(window.location.href)
  const tokenStr = query.token
  const uCloudIdStr = query.uCloudId
  const refreshTokenStr = query.refreshToken
  const inVisible = query.inVisible
  const fatherOrigin = query.origin
  const isRuiyiOld = query.isRuiyiOld
  const otherParams = query.otherParams
  const starOnline = query.starOnline

  if (fatherOrigin) {
    window.fatherOrigin = fatherOrigin
    if (whiteList && Array.isArray(whiteList) && !whiteList.includes(fatherOrigin)) {
      whiteList.push(fatherOrigin)
    }
  }
  // 预加载
  if (inVisible) {
    window.INVISIBLE = true
    return {
      shouldMountVue: false,
    }
  }
  if (isRuiyiOld) {
    store.commit('setStarRuiyiOld', true)
  }
  if (otherParams) {
    store.commit('setStarOtherParams', otherParams)
  }

  if (starOnline) {
    setLocalStoragItem('starOnline', 1)
  }

  if (tokenStr) {
    const token = decodeURIComponent(tokenStr)
    const uCloudId = decodeURIComponent(uCloudIdStr)
    const refreshToken = decodeURIComponent(refreshTokenStr)
    store.commit('setInXingCheng')
    store.commit('setadminUser', {
      UCloudId: uCloudId,
      Token: token,
      RefreshToken: refreshToken,
    })
  }

  if (query.luohuGpno) {
    let item = getLocalStoragItem('visual')

    item = item && JSON.parse(item)
    item = item || {}
    item['lastAreaHighId'] = {
      GpNo: query.luohuGpno,
      GpName: query.luohuGpName,
      Level: query.luohuLevel,
    }
    setLocalStoragItem('visual', JSON.stringify(item))
    // SetStoreCacheObj('visual', 'lastAreaHighId',  null);
  }

  const projectCode = query.projectCode

  if (projectCode) {
   await initProject({
      projectCode,
    })
    // store.dispatch("changeProjectcode", projectCode);

    // const projectRes = await Get({
    //   projectCode: projectCode,
    // });

    // if (projectRes.Result) {

    //   store.dispatch("changeProjectinfor", projectRes.Result);
    // };

    // console.log('葛煜商照地图', projectRes);

    // const userRes = await GetUserInfo();

    // if (userRes.Result) {
    //   const headUrl = projectRes.Result.HeadImagePath || 'https://appresource.opple.com/media/business/4974/20241114101350_76.png';

    //   store.dispatch("changeUserinfor", userRes.Result);
    //   store.dispatch("changeUserhead", headUrl);
    // };
  }

  if (tokenStr) {
    const url = new URL(window.location.href)
    url.searchParams.set('token', '')
    url.searchParams.set('uCloudId', '')
    url.searchParams.set('refreshToken', '')
    history.pushState(
      {
        projectCode: query.projectCode,
      },
      '',
      url.toString()
    )
  }
  setLocalStoragItem('starQuery', JSON.stringify(query))

  // const redirectUrl = query.redirectUrl;

  // if (redirectUrl) {
  //   setTimeout(() => {
  //     $router.push({ path: "visualMap/project" });
  //   }, 1000);
  // };
  return {
    shouldMountVue: true
  };
}

export async function initXingCheng() {
  const result = await isNeedInjectionToken()
  return result || { shouldMountVue: false };
}

window.addEventListener(
  'message',
  function (event) {
    if (event && whiteList.includes(event.origin) && event.data) {
      const message = event.data // 获取父页面发送的消息内容
      //console.log('接收到父页面消息1:', message);

      const payload = event.data.payload || {}
      // 对消息进行处理
      switch (event.data.type) {
        // 设置token
        case 'SET_TOKEN':
          store.commit('setadminUser', {
            UCloudId: payload.uCloudId,
            Token: payload.accessToken,
            RefreshToken: payload.refreshToken,
          })

          break
        // 设置在星辰内 会隐藏所有导航栏
        // 需要先加载一个隐形的iframe注入, 后面打开就不会有了
        case 'SET_IN_XINGCHENG':
          store.commit('setInXingCheng')
          break
        // 设置项目编码
        case 'SET_PROJECT_CODE':
          store.commit('setProjectcode', payload.projectCode)
          initProject({ projectCode: payload.projectCode, uuid: payload.uuid })
          break
        // 设置导航栏
        // 不需要预先加载 但是会有一个收缩的闪烁
        case 'CONTAINER_IN_XC':
          // store.commit('setIsShowSidebar', false);
          store.commit('setIsShowHeader', false)
          break
        case 'SET_AUTH':
          break
      }
    }
  },
  false
)

// 作为iframe内嵌星辰时,部分icon不显示
export function isXingchengShowIcon() {
  let result = store.state.isInXingCheng && !store.state.starRuiyiOld
  return result
}

//star OtherParams判断icon是否隐藏
export function isXingchengHideOtherIcon(code) {
  let result = isXingchengShowIcon()
  if (result && Array.isArray(store.state.starOtherParams) && store.state.starOtherParams.includes(code)) {
    return true
  }
  return false
}

export const OTHER_CODE_EMUMS = {
  HIDE_QUIT: 'hideQuit', // 电子地图隐藏退出按钮code
}
